'use strict'

import React from 'react'
import './radio.scss'

const defaultColor = '#4A4A4A';

function isStringAndColorValue(str) {
    return (typeof str === 'string' || str instanceof String) && str.match(/^#(([a-fA-F]|\w){3}|([a-fA-F]|\w){6})$/gi);
}

function getColors(propsColor) {
    const colors = {};
    const isPropsColor = isStringAndColorValue(propsColor);

    colors.backgroundColor = isPropsColor ? propsColor : defaultColor;
    if (!isPropsColor && isStringAndColorValue(propsColor.backgroundColor)) {
        colors.backgroundColor = propsColor.backgroundColor;
    }

    colors.borderColor = isPropsColor ? propsColor : defaultColor;
    if (!isPropsColor && isStringAndColorValue(propsColor.borderColor)) {
        colors.borderColor = propsColor.borderColor;
    }

    colors.uncheckedBorderColor = isPropsColor ? propsColor : defaultColor;
    if (!isPropsColor && isStringAndColorValue(propsColor.uncheckedBorderColor)) {
        colors.uncheckedBorderColor = propsColor.uncheckedBorderColor;
    }

    colors.tickColor = isStringAndColorValue(propsColor.tickColor)
        ? propsColor.tickColor
        : '#FFFFFF';

    return colors;
}

class Radio extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = this.setProps(props)
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps, nextContext) {
        const data = this.setProps(nextProps)
        this.setState(data)
    }

    setProps(props) {
        return {
            backAnimationDuration: props.backAnimationDuration || 10,
            borderthickness: props.borderthickness || 3,
            checked: props.checked || false,
            className: props.className || '',
            color: props.color || {},
            style: props.style || {},
            delay: props.delay || 0,
            id: props.id || '',
            size: props.size || 2,
            tickAnimationDuration: props.tickAnimationDuration || 100,
            tickSize: props.tickSize || 3,
            disabled: props.disabled || false,
        }
    }

    render() {
        const classes = ['Checkbox'];
        classes.push(this.state.className);
        classes.push(this.state.checked ? 'checked' : 'unchecked');

        const scale = 0.25 + (0.25 * this.state.size);
        const attrId = this.state.id !== '' ? { id: this.state.id } : {};
        const colors = getColors(this.state.color);
        if (this.state.disabled) {
            const gray = '#6b6a74'
            colors.backgroundColor = colors.borderColor = colors.uncheckedBorderColor = gray
        }
        const tickTransitionDelay = 10;
        const squareTransitionDelay = 10;

        return (
            <div
                className={classes.join(' ')}
                style={this.state.style}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    transform={`scale(${scale})`}
                >
                    <circle
                        className="circle"
                        cx="12"
                        cy="12"
                        r="10"
                        fill={this.state.checked ? colors.backgroundColor : "#ffffff"}
                        stroke={this.state.checked
                            ? colors.borderColor
                            : colors.uncheckedBorderColor}
                        strokeWidth={`${this.state.borderthickness}px`}
                        style={{
                            transitionDelay: `${squareTransitionDelay}ms`,
                            transitionDuration: `${this.state.backAnimationDuration}ms`,
                        }}
                    />
                    <path
                        className="tick"
                        d="M6,6 v8 h16"
                        strokeWidth={this.state.tickSize}
                        stroke={colors.tickColor}
                        fill="none"
                        transform="rotate(-45, 12, 12)"
                        style={{
                            transitionDelay: `${tickTransitionDelay}ms`,
                            transitionDuration: `${this.state.tickAnimationDuration}ms`,
                        }}
                    />
                </svg>
            </div>
        );
    }
}

export default Radio


// WEBPACK FOOTER //
// ./src/common/radio/radio.component.jsx